export const UPDATE_FORM_VALUES = Symbol('auth/signin/UPDATE_FORM_VALUES');
